import { ACTION_CLEAR_SEARCH, ACTION_SEARCH, ACTION_SET_AID_INFO } from '../constants/actions';

export function SetSearch(search: string, utilityType = '') {
  return {
    payload: { search, utilityType },
    type: ACTION_SEARCH
  };
}

export function SetAidInfo(aidId: number = 0, CNP: string = '') {
  return {
    payload: { aidId, CNP },
    type: ACTION_SET_AID_INFO
  };
}

export function SetAdditionInfo(additionId: number = 0, additionCNP: string = '') {
  return {
    payload: { additionId, additionCNP },
    type: ACTION_SET_AID_INFO
  };
}

export function ClearSearch() {
  return {
    payload: {},
    type: ACTION_CLEAR_SEARCH
  };
}
